export default "__VITE_ASSET__BmE$p5dj__"